import React from 'react';
import { Table, Row, Upload, Modal, Button, Alert, Space, message, Flex } from 'antd';
import { AimOutlined, FormOutlined, ImportOutlined, UploadOutlined, EditOutlined, DeleteOutlined, QrcodeOutlined} from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import usePagination from '../../components/pagination';
import SearchButton from '../../components/search-button';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [shopId, setShopId] = React.useState(null);
    const [customerList, setCustomerList] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [isOpen, setIsOpen] = React.useState(false);
    const [file, setFile] = React.useState(null);
    const [customerParams, setCustomerParams] = React.useState({
        page: 1,
        pageSize: 10,
    });

    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            console.log('page', page, pageSize);
            const params = {
                ...customerParams,
                page,
                pageSize
            };
            setCustomerParams(params);
            getCustomerList(params);
        },
    });

    // React.useEffect(() => {
    //     const fetchShopId = async () => {
    //         const id = await getCurrentShopId();
    //         setShopId(id);
    //     };
    //     fetchShopId();
    // }, []);

    const columns = [
        // {
        //     title: '客户ID',
        //     dataIndex: 'customerId',
        // },
        {
            title: '客户名称',
            dataIndex: 'username',
            render: (text, r) => <div>{text}<br/>ID：{r.customerId}</div>,
        },
        {
            title: '客户电话',
            dataIndex: 'phoneNo',
        },
        // {
        //     title: '客户ID',
        //     dataIndex: 'customerId',
        // },
        {
            title: 'openid',
            dataIndex: 'wxOpenid',
        },
        {
            title: '消费金额',
            dataIndex: 'totalConsume',
            render: (text) => <div>{text/100}</div>,
        },
        {
            title: '所在区',
            dataIndex: 'county',
            render: (text, record) => <span>{`${record.city || ''}${text || ''}`}</span>
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'customerId',
            width: 60,
            render: (text, record) => {
                return <Space size={'middle'}> 
                    <a onClick={() => viewQRcode(record.customerId)}><QrcodeOutlined /></a>
                    <a style={{whiteSpace: 'nowrap'}} href={`/customer/create?customerId=${record.customerId}&action=edit`}>
                        <EditOutlined />
                    </a>
                    <a style={{whiteSpace: 'nowrap'}} onClick={() => onDelete(text)}>
                        <DeleteOutlined />
                    </a>
                </Space>
            }
        }
    ];

    const viewQRcode = async (customerId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/shop/qrcode?shareCustomerId=${customerId}&shopId=${shopId}`);
        const result = await res.json();
        if (result && result.success) {
            Modal.info({
                icon: null,
                title: '客户分享二维码',
                content: <div style={{textAlign: 'center'}}><img src={`https://img.yxdj.tech/${result.data.url}`} style={{width: 200}} /></div>,
            });
        }
    }

    const onDelete = (customerId) => {
        Modal.confirm({
            title: '删除客户',
            content: '确定要删除该客户吗？',
            onOk: async () => {
                await deleteCustomer(customerId);
                getCustomerList(customerParams);
            }
        });
    }

    const deleteCustomer = async (customerId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/customer/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                shopId,
                customerId
            })
        });
        const result = await res.json();

        if (result.success) {
            message.success('删除成功');
            return result.data;
        }
        message.error(result.data);
        return null;
    }

    // 获取客户信息
    const getCustomerList = async (params) => {
        const shopId = await getCurrentShopId();
        if (!shopId) return;
        // 把params转成query字符串
        const query = Object.keys(params)
            .map((key) => `${key}=${params[key]}`)
            .join('&');
        
        const res = await fetch(`/api/customer/list?shopId=${shopId}&${query}`);
        const result = await res.json();
        if (result && result.success) {
            setCustomerList(result?.data?.rows || []);
            setTotal(result?.data.count);
        }
    }

    const onImportClick = (e) => { 
        setIsOpen(true);
        e.preventDefault();
    };

    const importCustomer = async () => { 
        const shopId = await getCurrentShopId();
        if (!file) {
            message.warning('请选择一个文件');
            return;
        }

        // 生成仅包含字母和数字的随机文件名
        const randomFileName = Array.from({ length: 8 }, () =>
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'[Math.floor(Math.random() * 62)]
        ).join('');
        const fileExtension = file.name.split('.').pop();
        const newFileName = `${randomFileName.toLocaleLowerCase()}.${fileExtension}`;

        // 创建新的 File 对象并替换文件名
        const renamedFile = new File([file], newFileName, {
            type: file.type,
            lastModified: file.lastModified,
        });

        const formData = new FormData();
        formData.append('shopId', shopId);
        formData.append('excelFile', renamedFile);

        try {
            const res = await fetch('/api/customer/import?shopId='+shopId, {
                method: 'POST',
                body: formData,
            });

            const result = await res.json();

            if (result && result.success) {
                message.success(result.data);
                getCustomerList({...customerParams, shopId}); // 刷新客户列表
                setIsOpen(false); // 关闭模态框
            } else {
                message.error(result.data || '导入失败');
            }
        } catch (err) {
            console.error('导入客户出错:', err);
            message.error(err);
        }
    };

    React.useEffect(() => {
        getCustomerList({...customerParams});
    }, []);

    const handleFileChange = (info) => {
        console.log('文件改变', info);
        const file = info.file;
        setFile(file);
        if (file.status === 'done') {
          console.log('上传完成', file.response);
        }
    };

    return (
        <div>
            <SwitchShop />
            <Modal title='导入客户' open={isOpen} 
                destroyOnClose={true} 
                onOk={importCustomer}
                onCancel={() => setIsOpen(false)}
            >
                <Alert message="建议使用电脑操作" type="info" showIcon />
                <Space direction="vertical"> 
                    <div>1. 下载模版，<a href='https://img.yxdj.tech/yxdj-system/excel/template.xlsx'>点击下载</a></div>
                    <div>2. 填写客户信息，按模版填写</div>
                    <div>3. 上传文件(最大为5M)</div>
                    <Upload name='excelFile'
                        customRequest={({ file }) => {
                            // 这里可以自定义上传逻辑
                            console.log('开始上传:', file);
                        }}
                        beforeUpload={() => false}
                        onChange={handleFileChange}
                    >
                        <Button icon={<UploadOutlined />}>上传文件</Button>
                    </Upload>
                </Space>
            </Modal>
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/customer/create" text="新建客户">
                    <FormOutlined style={iconStyle} />
                </NavItem>

                <NavItem text="导入客户" onClick={onImportClick}>
                    <ImportOutlined style={iconStyle} />
                </NavItem>

                {/* <NavItem href="/customer/export" text="导出客户">
                    <ExportOutlined style={iconStyle} />
                </NavItem> */}

                <NavItem href="/customer/discover" text="发现客户">
                    <AimOutlined style={iconStyle} />
                </NavItem>
            </Row>
            <Flex align='center' gap={10}>
                <h2>客户列表</h2>
                <SearchButton searchOptions={{
                    username: '用户名',
                    phoneNo: '电话',
                    customerId: '客户ID'
                }} onSearch={(params) => getCustomerList({...customerParams, ...params, page: 1})} />
            </Flex>
            <SearchButton.Tags style={{margin: '0 0 10px 0'}} onClose={(params) => {
                let ps = {...customerParams, page: 1};
                delete ps[params.key];
                getCustomerList(ps);
            }} options={{
                username: '用户名',
                phoneNo: '电话',
                customerId: '客户ID'
            }} />
            <div>
                <Table pagination={pagination} size='small' rowKey={'customerId'} columns={columns} dataSource={customerList} scroll={{ x: 'max-content' }} />
            </div>
        </div>
    );
};